export default "__VITE_ASSET__CV_5OiA9__"